import { ROUTES } from "./consts";
import type { Route } from "./types";

/** return the title matching the path, or a fallback */
export const getNavTitle = (
  url: URL,
  params: Record<string, string> = {},
  fallbackStrategies = ["startsWith"],
): string | null => {
  const route = getRoute(url, fallbackStrategies);
  const { title } = route ?? {};

  if (title === undefined) return "Unknown page";
  if (title === null) return null; // `null` means "no title"

  /** assign search params to `params` */
  Object.assign(params, Object.fromEntries(url.searchParams));
  for (const key in params)
    if (url.pathname === "/pay" && key === "for")
      params[key] = params[key]?.replace(/\b\w/g, (c) => c.toUpperCase()); // ensure "Title Case" on /pay

  /** replace any {{placeholder}} with the corresponding value in `params` (falls back to an empty string) */
  const interpolated = title
    .replace(/\{\{([^}]+)\}\}/g, (_, key: string) => params?.[key.trim()] ?? "")
    .trim();

  return interpolated.trim();
};

/** return the route matching the path, or a fallback */
export const getRoute = (
  url: URL,
  fallbackStrategies = ["startsWith"],
): Route => {
  let route = ROUTES[url.pathname];

  /** attempt fallback strategies */
  // [startsWith]: "/settings/account" → "/settings"
  if (route === undefined && fallbackStrategies.includes("startsWith"))
    route = ROUTES[`/${url.pathname.split("/")[1]}`];

  if (!route) throw new Error(`No route found for path: ${url.pathname}`);

  return route;
};
